import { render, staticRenderFns } from "./ScreenLaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=template&id=1c163955&lang=true&"
import script from "./ScreenLaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports